/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {AfterContentInit, ContentChildren, Directive, ElementRef, Input, OnChanges, OnDestroy, QueryList, Renderer} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {NavigationEnd, Router} from '../router';
import {containsTree} from '../url_tree';

import {RouterLink} from './router_link';

interface RouterLinkActiveOptions {
  exact: boolean;
}
export class RouterLinkActive implements OnChanges, OnDestroy, AfterContentInit { private links: QueryList<RouterLink>;
  private classes: string[] = [];
  private subscription: Subscription; private routerLinkActiveOptions: RouterLinkActiveOptions = {exact: false};

  /**
   * @internal
   */
  constructor(private router: Router, private element: ElementRef, private renderer: Renderer) {
    this.subscription = router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        this.update();
      }
    });
  }

  ngAfterContentInit(): void {
    this.links.changes.subscribe(s => this.update());
    this.update();
  }
  set routerLinkActive(data: string[]|string) {
    if (Array.isArray(data)) {
      this.classes = <any>data;
    } else {
      this.classes = data.split(' ');
    }
  }

  ngOnChanges(changes: {}): any { this.update(); }
  ngOnDestroy(): any { this.subscription.unsubscribe(); }

  private update(): void {
    if (!this.links || this.links.length === 0) return;

    const currentUrlTree = this.router.parseUrl(this.router.url);
    const isActive = this.links.reduce(
        (res, link) =>
            res || containsTree(currentUrlTree, link.urlTree, this.routerLinkActiveOptions.exact),
        false);

    this.classes.forEach(
        c => this.renderer.setElementClass(this.element.nativeElement, c, isActive));
  }
/** @nocollapse */
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[routerLinkActive]'}, ] },
];
/** @nocollapse */
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: Router, },
{type: ElementRef, },
{type: Renderer, },
];
/** @nocollapse */
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'links': [{ type: ContentChildren, args: [RouterLink, ] },],
'routerLinkActiveOptions': [{ type: Input },],
'routerLinkActive': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
